import React, { useState } from "react";

export default function Certificates() {
  const [uploadedFile, setUploadedFile] = useState(null);
  const [previewURL, setPreviewURL] = useState(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type === "application/pdf") {
      setUploadedFile(file);
      setPreviewURL(URL.createObjectURL(file));
    } else {
      alert("Please upload a valid PDF file.");
    }
  };

  const handleSave = () => {
    if (!uploadedFile) return;
    // TODO: Replace with backend upload
    alert(`Uploaded certificate: ${uploadedFile.name}`);
  };

  return (
    <div className="max-w-3xl mx-auto p-6 space-y-6">
      <h2 className="text-2xl font-bold">Certificate Template</h2>

      <div className="bg-white p-6 rounded shadow border space-y-4">
        <p className="text-gray-700">
          Upload a PDF certificate template. Placeholder text like <code>{{user}}</code> and{" "}
          <code>{{course}}</code> will be replaced dynamically on completion.
        </p>

        <input
          type="file"
          accept="application/pdf"
          onChange={handleFileChange}
          className="border p-2 rounded w-full"
        />

        {uploadedFile && (
          <div className="text-sm text-gray-600">
            <p>Selected File: <strong>{uploadedFile.name}</strong></p>
            {previewURL && (
              <iframe
                src={previewURL}
                title="Certificate Preview"
                className="w-full h-96 border rounded mt-4"
              />
            )}
          </div>
        )}

        <button
          onClick={handleSave}
          className="mt-4 bg-green-600 text-white px-6 py-2 rounded hover:bg-green-700"
        >
          Save Template
        </button>
      </div>
    </div>
  );
}
